import { PhoneDataAPIModel } from '@/generated/api/fps/api';
import { PhoneAPIModel, PhoneAPIModelStatusEnum } from '@/generated/api/fps/core';
import { PhoneInfo } from '@/model/identification/types';

export const parsePhone = (phone: string): string => (phone.length > 0 ? phone.replace(/[^\d]/g, '').substr(1) : phone);
export const parsePhoneInfo = ({ number, status, ...rest }: PhoneDataAPIModel | PhoneAPIModel): PhoneInfo => ({
  number: parsePhone(number),
  status: PhoneAPIModelStatusEnum[status],
  ...rest,
});
